import React from 'react';
import { Toaster as OriginalToaster, ToasterProps } from 'sonner';

const Toaster: React.FC<ToasterProps> = (props) => (
  <OriginalToaster {...props} />
);

Toaster.displayName = 'Toaster';

export { Toaster };
